import {BadgeStatus} from '@mdsol/onex-design'
import React from 'react'
import {FC} from 'react'
import {CellPropsType} from './cellPropsType'

const JobRequestCategory: FC<CellPropsType> = ({cell}) => {
  const value = cell.getValue()
  return (
    <BadgeStatus>
      {value}
    </BadgeStatus>
  )
}

export default JobRequestCategory
